export default __webpack_public_path__ + "static/media/February2012.a3c32cbf.png";